export const controlType ={// 0 = 1.Person Control, 1 = OrbitControl
    firstPersonControl:  0,
    orbitControl: 1
};